import React, { useState, useEffect } from 'react';
import './FormularioCombustible.css';

const FormularioCombustible = ({ vehiculos = [], onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    fecha: '',
    tipoGasolina: '',
    vehiculo: '',
    litrosConsumidos: '',
    monto: '',
    numeroTicket: ''
  });

   // Filtro por área vehicular
  const [areaFiltro, setAreaFiltro] = useState(''); // '', 'reparto', 'proveedor', 'empleado'

  // --- Estado para los registros ---
  const [registros, setRegistros] = useState([]);

  // ✅ Cargar registros guardados cada vez que se abre el modal
  useEffect(() => {
    const registrosGuardados = localStorage.getItem('registrosCombustible');
    if (registrosGuardados) {
      try {
        const datos = JSON.parse(registrosGuardados);
        if (Array.isArray(datos)) setRegistros(datos);
      } catch (err) {
        console.error('Error al leer registros guardados:', err);
      }
    }
  }, []); // se ejecuta solo al montar

  // ✅ Guardar los registros en localStorage cada vez que cambien
  useEffect(() => {
    localStorage.setItem('registrosCombustible', JSON.stringify(registros));
  }, [registros]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const nuevoRegistro = { ...formData };

    // Agrega el nuevo registro al estado y al localStorage
    setRegistros((prev) => {
      const actualizados = [...prev, nuevoRegistro];
      localStorage.setItem('registrosCombustible', JSON.stringify(actualizados));
      return actualizados;
    });

    // Envía los datos al componente padre si es necesario
    if (onSubmit) onSubmit(nuevoRegistro);

    // Limpia el formulario
    setFormData({
      fecha: '',
      tipoGasolina: '',
      vehiculo: '',
      litrosConsumidos: '',
      monto: '',
      numeroTicket: ''
    });
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content combustible-modal">
        <div className="modal-header combustible-header">
          <h2>Registrar Consumo de Combustible</h2>
          <button className="close-button" onClick={handleCancel}>×</button>
        </div>

        {/* --- FORMULARIO --- */}
        <form onSubmit={handleSubmit} className="formulario-combustible">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="fecha">Fecha:</label>
              <div className="input-with-icon">
                <input
                  type="date"
                  id="fecha"
                  name="fecha"
                  value={formData.fecha}
                  onChange={handleInputChange}
                  required
                />
                <span className="calendar-icon">📅</span>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="tipoGasolina">Tipo de gasolina:</label>
              <select
                id="tipoGasolina"
                name="tipoGasolina"
                value={formData.tipoGasolina}
                onChange={handleInputChange}
                required
              >
                <option value="">Seleccionar...</option>
                <option value="Magna">Magna</option>
                <option value="Premium">Premium</option>
                <option value="Diésel">Diésel</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="areaVehicular">Área vehicular:</label>
              <select
                id="areaVehicular"
                name="areaVehicular"
                value={areaFiltro}
                onChange={(e) => {
                  setAreaFiltro(e.target.value);
                  // al cambiar área, limpiar selección de vehículo
                  setFormData(prev => ({ ...prev, vehiculo: '' }));
                }}
              >
                <option value="">Todas</option>
                {/* opciones fijas para consistencia con FormularioAutos */}
                <option value="reparto">Unidades de reparto</option>
                <option value="proveedor">Proveedores</option>
                <option value="empleado">Empleados</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="vehiculo">Vehículo:</label>
              <select
                id="vehiculo"
                name="vehiculo"
                value={formData.vehiculo}
                onChange={handleInputChange}
                required
              >
                <option value="">Seleccionar...</option>
                {vehiculos
                  .filter(v => !areaFiltro || v.areaVehicular === areaFiltro)
                  .map((v) => {
                    // Etiqueta amigable según el área
                    let label = v.placas || v.nombre || v.id;
                    if (v.areaVehicular === 'reparto') {
                      label = `${v.placas || ''} ${v.marca || ''} ${v.modelo || ''}`.trim();
                    }
                    if (v.areaVehicular === 'proveedor') {
                      label = `${v.nombreProveedor || 'Proveedor'} (${v.telefonoProveedor || '—'})`;
                    }
                    if (v.areaVehicular === 'empleado') {
                      label = `${v.nombreEmpleado || 'Empleado'} (${v.numeroEmpleado || '—'})`;
                    }
                    return (
                      <option key={v.id || label} value={label}>
                        {label}
                      </option>
                    );
                  })}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="litrosConsumidos">Litros consumidos:</label>
              <input
                type="number"
                id="litrosConsumidos"
                name="litrosConsumidos"
                value={formData.litrosConsumidos}
                onChange={handleInputChange}
                required
                step="0.01"
                min="0"
                placeholder="0.00"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="monto">Monto ($):</label>
              <div className="input-with-spinner">
                <input
                  type="number"
                  id="monto"
                  name="monto"
                  value={formData.monto}
                  onChange={handleInputChange}
                  required
                  step="0.01"
                  min="0"
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="numeroTicket">Número de ticket:</label>
              <input
                type="text"
                id="numeroTicket"
                name="numeroTicket"
                value={formData.numeroTicket}
                onChange={handleInputChange}
                required
                placeholder="Ej: TK-001234"
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-cancel" onClick={handleCancel}>
              Cancelar
            </button>
            <button type="submit" className="btn-submit combustible-btn">
              Registrar Combustible
            </button>
          </div>
        </form>

        {/* --- TABLA DE REGISTROS --- */}
        {registros.length > 0 && (
          <div className="tabla-combustible">
            <h3>Registros Capturados</h3>
            <table>
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Tipo Gasolina</th>
                  <th>Vehículo</th>
                  <th>Litros</th>
                  <th>Monto ($)</th>
                  <th>Número de Ticket</th>
                </tr>
              </thead>
              <tbody>
                {registros.map((registro, index) => (
                  <tr key={index}>
                    <td>{registro.fecha}</td>
                    <td>{registro.tipoGasolina}</td>
                    <td>{registro.vehiculo}</td>
                    <td>{registro.litrosConsumidos}</td>
                    <td>{registro.monto}</td>
                    <td>{registro.numeroTicket}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormularioCombustible;
